// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-promo-steps[data-v-75b740d0]  .step-item{max-width:335px}@media(max-width: 1199.98px){.section-promo-steps[data-v-75b740d0]  .horizontal-steps{max-width:335px}}.section-promo-steps[data-v-75b740d0]  .h4.font-weight-bold{font-weight:500 !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
